export default __webpack_public_path__ + "static/media/2.307cf196.png";